// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"ef7dd7960bb73ad74fac","2996":"045423bca521f8bd9fd0"}[chunkId] + ".css";
};